import copyIcon from '@image/copy-icon.svg';
import { Button } from '@ax/ui';
import style from './EditorCopyButton.module.scss';
import toast from 'react-hot-toast';

interface EditorCopyButtonProps {
  section: string;
  content: string;
}

const EditorCopyButton = ({ section, content }: Readonly<EditorCopyButtonProps>) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        toast('Copied to clipboard', {
          duration: 1000,
          style: {
            borderRadius: '50px',
            background: '#e2e9ff',
            color: '#344bc6',
            boxShadow: 'none',
            fontSize: '14px',
            padding: '5px 10px',
          },
        });
      })
      .catch((err) => {
        console.error(`Failed to copy text for section: ${section}`, err);
      });
  };

  return (
    <>
      <Button
        label={section}
        image={copyIcon}
        className={style.lexical__editor__copy_button}
        small
        outline
        onClick={handleCopy}
      />
    </>
  );
};

export default EditorCopyButton;
